import dayjs from 'dayjs';
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import EditModal from '../../warning/TodayPlan/components/EditModal.vue'
import { EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'

const esp = new EmployeeServiceProxy()
@Component({
  components: {
    EditModal
  }
})
export default class InnerBody extends Vue {
  get columns() {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'actions',
        key: 'actions',
        width: 100,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            <div>
            { (_record.planStatus == 1 || _record.planStatus == 2 ) ?
              <a
                type="link"
                v-acl="page_maintenance_plan_implement_plan"
                onClick={(e) => {
                  e.stopPropagation();
                  this.view(_record);
                }}
                >
                {this.$t("page_plan_maintenance_edit_execution")}
              </a> : "" }
              { _record.planStatus == 3 ?
                <a
                  type="link"
                  v-acl="page_maintenance_plan_implement_plan"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.checkRecord(_record);
                  }}
                  >
                  {this.$t("page_plan_maintenance_check_record")}
                </a> : ""
              }
              { (_record.planStatus == 1 || _record.planStatus == 2 ) ?<a-divider type="vertical" /> : "" }
              { (_record.isAuto == 0 && (_record.planStatus == 1 || _record.planStatus == 2) ) ? <a
                type="link"
                v-acl="page_maintenance_plan_edit_plan"
                onClick={(e) => {
                  e.stopPropagation();
                  this.edit(_record);
                }}
              >
                {this.$t("edit")}
              </a>: "" }
            </div>
          );
        },
      },
      {
        title: this.$t('page_plan_maintenance_application_No'),
        dataIndex: 'code',
        key: 'code',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_equipment_coding'),
        dataIndex: 'deviceCode',
        key: 'deviceCode',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_equipment_name'),
        dataIndex: 'deviceName',
        key: 'deviceName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_equipment_type'),
        dataIndex: 'deviceTypeName',
        key: 'deviceTypeName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_program'),
        dataIndex: 'projectName',
        key: 'projectName',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value}
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_last_maintenance_date'),
        dataIndex: 'preMaintainTime',
        key: 'preMaintainTime',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : "" }
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_period'),
        dataIndex: 'intervalTime',
        key: 'intervalTime',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_next_maintenance_date'),
        dataIndex: 'maintainDate',
        key: 'maintainDate',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : "" }
            </span>
          )
        },
      }
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: "" }) readonly current: String;
  @Prop({ default: "" }) readonly pageSize: String;
  @Prop({ default: "" }) readonly total: String;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;
  @Prop({ default: "" }) readonly selectId: String;
  @Prop({ default: () => [] }) readonly selectedRowKeys: Array<any>;

  editVisible = false
  employeesList = []
  editData = {}

  onSelectChange(selectedRowKeys,selectedRows) {
    console.log(selectedRows,'row')
    this.$emit('onSelectChange', selectedRowKeys,selectedRows)
  }

  checkRecord(record){
    this.editData = record
    esp.getPageEmployees(1,{statusList: [1]} as any,"",999999).then(res =>{
      this.employeesList = res.records
    })
    this.editVisible = true
  }

  handleTableChange(current: number, pageSize: number) {
    const pager = {
      pageSize: pageSize,
      current: current
    }
    this.$emit('handleTableChange', pager)
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(record) {
    this.$emit('clickRow', record.id)
  }
  
  edit(record) {
    this.clickRow(record)
    this.$emit('edit',record)
  }

  view(record) {
    this.clickRow(record)
    this.$emit('implement',record)
  }

  close(){
    this.editVisible = false
  }

  reload(){
    this.editVisible = false
    this.$emit('reload')
  }

  render() {
    return (
      <div>
        <ml-table
          pagination={false}
          columns={this.columns}
          dataSource={this.data}
          canChangeColWidth={true}
          bordered
          rowKey="id"
          selectRowKey={this.selectId}
          loading={this.loading}
          scroll={{ y: this.height, x: 1900 }}
          row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }}
          customRow={(record) => {
            return {
              on: { // 事件
                click: () => this.clickRow(record),       // 点击行
              },
            };
          }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          show-total={total => `${this.showTotal(total)}`}
          current={this.current}
          pageSize={this.pageSize}
          total={this.total}
          on-change={this.handleTableChange}
          on-showSizeChange={this.handleTableChange}
        />
        
        <edit-modal
          visible={this.editVisible}
          employeesList={this.employeesList}
          data={this.editData}
          onClose={() => this.close()}
          onReload={() => this.reload()}
        ></edit-modal>
      </div>
    )
  }
}